document.addEventListener('DOMContentLoaded', function() {
    function insertCustomSearch() {
        const inputTemplate = `<div class="ca-burlap-007-search"><input placeholder="Search for a spice to bundle"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 37 40"><path d="M35.6 36l-9.8-9.8c4.1-5.4 3.6-13.2-1.3-18.1-5.4-5.4-14.2-5.4-19.7 0-5.4 5.4-5.4 14.2 0 19.7 2.6 2.6 6.1 4.1 9.8 4.1 3 0 5.9-1 8.3-2.8l9.8 9.8c.4.4.9.6 1.4.6s1-.2 1.4-.6c.9-.9.9-2.1.1-2.9zm-20.9-8.2c-2.6 0-5.1-1-7-2.9-3.9-3.9-3.9-10.1 0-14C9.6 9 12.2 8 14.7 8s5.1 1 7 2.9c3.9 3.9 3.9 10.1 0 14-1.9 1.9-4.4 2.9-7 2.9z"></path></svg></div>`;
        const notResultsTemplate = `<p id="no-results" class=""></p>`
        
        const filterContainer = document.querySelector('.bundle-builder-app--bundle--filter');
        const appProductContainer = document.querySelector('.bundle-builder-app--products');

        if (filterContainer) {
            filterContainer.insertAdjacentHTML('beforeend', inputTemplate);
            appProductContainer.insertAdjacentHTML('beforeend', notResultsTemplate)
        } else {
            console.error('Filter container not found');
        }
    }

    function waitForElm(selector) {
        return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
    
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
            }
        });
    
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        });
    }

    function SearchProducts() {
        const searchInput = document.querySelector('.ca-burlap-007-search input');
        const noProductsFound = document.querySelector('#no-results');

        searchInput.addEventListener('input', function () {
            const searchTerm = this.value.toLowerCase();
        
            filterProducts(searchTerm);
        });

        filterProducts(searchInput.value.toLowerCase());
        
        function filterProducts(searchTerm) {
            const products = document.querySelectorAll('.bundle-builder-app--bundle--product');
            let hasVisibleProduct = false;

            products.forEach(product => {
                const productTitle = product.querySelector('.bundle-builder-app--bundle--product-name').textContent.toLowerCase();
                if (productTitle.includes(searchTerm)) {
                    product.classList.remove('dn-i');
                    hasVisibleProduct = true;
                } else {
                    product.classList.add('dn-i');
                }
            });

            if (!hasVisibleProduct) {
                noProductsFound.textContent = `Sorry, nothing found for "${searchTerm}".`;
                noProductsFound.classList.remove('dn-i');
            } else {
                noProductsFound.classList.add('dn-i');
            }
        }
    }

    function filterCategoryTags() {
      const tagFilters = document.querySelectorAll('.bundle-builder-app--bundle--filter--select option');
        tagFilters.forEach((option) => {
          
          if (option.value.indexOf('Category_') === 0 || option.value.indexOf('All Spices') == 0 ) {
            
            option.textContent = option.value.replace('Category_', '');

            if (option.value.indexOf('All Spices') == 0) {
              option.textContent = option.value.replace('(Internal)', '');
            }
           
          } else {
            option.remove();
          }
            
        });
    }

    function OpenTheModal() {
      const Images = document.querySelectorAll('.bundle-builder-app--bundle--product-image');
      if (Images.length > 0) {
        
        Images.forEach((image) => {
          image.addEventListener('click', () => {
            
            const bundleCart = image.closest('.bundle-builder-app--bundle--product')
                  bundleCart.querySelector('.bundle-builder-app--bundle--product--show-more').click();
          });
        });

      } else {
        console.warn('No se encontraron imágenes con la clase especificada.');
      }
    }
    
    
    
    waitForElm('.bundle-builder-app--bundle--filter').then((elm) => {
        insertCustomSearch();
        SearchProducts();
        OpenTheModal();
        filterCategoryTags();

    });

    document.addEventListener('change', function(event) {
        if (event.target.matches('.bundle-builder-app--bundle--filter--select')) {
            SearchProducts();
            filterCategoryTags();
        }
    })

    function AddToBundle() {
        const element = document.querySelector('.bundle-builder-app--bundle--discount-summary');
        if (element) {
          const addToBundleButton = document.querySelector('.bundle-builder-app--bundle--add-to-cart-button');
          if (addToBundleButton) {
           
    
            let childCount = document.querySelector('.bundle-builder-app--bundle--discount-summary');
            if (childCount.childElementCount > 0) {

              addToBundleButton.removeAttribute('disabled');
            } else {
              
              addToBundleButton.setAttribute('disabled', '');
            }
          }

          
        }
      }
    
      AddToBundle();
    
      const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            observer.disconnect(); 
            AddToBundle();
        
            observer.observe(document.body, {
              childList: true,
              subtree: true,
              attributes: true
            }); 
          }
        }
      });
    

      observer.observe(document.body, {
        childList: true,  
        subtree: true,  
        attributes: true
      });
});

